<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_MOMAOB')"
    :close-on-click-modal="false"
  >
    <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_AccountTitleName') }}</span>
    <el-input disabled :value="accountTitle?accountTitle.accountTitle+' '+accountTitle.accountTitleName:''" style="width: 200px;margin-bottom: 5px" />
    <div class="section row-grid">
      <cargo-ag-grid
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="accountTitleAuxiliaryBalances"
        style="min-height: 500px"
      />
    </div>
    <div slot="footer">
      <el-button type="primary" @click="addAuxiliaryEvent">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
      <el-button type="danger" @click="removeAuxiliaryEvent">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
      <el-button type="primary" @click="saveAuxiliaryEvent">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button type="primary" @click="closeHandler">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as accountTitleAuxiliaryBalanceApi from '@/api/financeManage/accountTitleAuxiliaryBalance'
import * as accountTitleApi from '@/api/financeManage/accountTitle'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'TitleAuxiliaryDialog',
  props: {
    visible: { type: Boolean, required: true },
    accountSet: { type: Object, default: null },
    accountTitle: { type: Object, default: null },
    fiscalPeriod: { type: Object, default: null },
    accountTitleBalance: { type: Object, default: null },
    currency: { type: String, default: null },
    isMultiCurrency: { type: Boolean, required: false }
  },
  data() {
    return {
      locked: true,
      accountTitleAuxiliaryBalances: [], // rowData
      innerVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true,
          suppressMenu: true,
          suppressMovable: true,
          headerClass: 'text-center'
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor
        }
      }
    }
  },
  computed: {
    columnDefs() {
      return this.initGridColumns()
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        this.loadAccountTitleAuxiliaryBalance()
        this.showColumn()
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
  },
  methods: {
    initGridColumns() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.accountTitle.auxiliaryCustomer ? this.$t('CargoMsg.Cargo_Customer') : this.$t('CargoMsg.Cargo_Vendor'),
          field: 'accountClient',
          suppressMenu: true,
          width: 150,
          hide: !(this.accountTitle.auxiliaryCustomer || this.accountTitle.auxiliarySupplier),
          editable: !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: 'chineseName',
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              selectMethodParams: { customer: true },
              callbackParams: { key: 'cmpIdx' },
              callbackMethodType: 'value'
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Staff'),
          field: 'staffId',
          suppressMenu: true,
          width: 150,
          hide: !this.accountTitle.auxiliarySales,
          editable: !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: 'chineseName',
              selectType: TYPE_NAMES.basic_data_User,
              methodParams: { category: 'role', shape: '' },
              callbackParams: { key: 'userId' },
              callbackMethodType: 'value'
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Department'),
          field: 'department',
          suppressMenu: true,
          width: 150,
          hide: !this.accountTitle.auxiliaryDepartment,
          editable: !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: 'chineseName',
              selectType: TYPE_NAMES.basic_data_Department,
              callbackParams: { key: 'departmentId' },
              callbackMethodType: 'value'
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Direction'),
          field: 'debitCrebit',
          suppressMenu: true,
          width: 150,
          valueFormatter: params => {
            return this.debitCrebitLablFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'accountTitleName',
          suppressMenu: true,
          width: 150,
          hide: !this.isMultiCurrency,
          editable: !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              callbackParams: { key: 'currency' },
              callbackMethodType: 'value'
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BalanceCNY'),
          field: 'balanceCurrencyRmb',
          width: 200,
          // 是否开启编辑
          editable: !this.locked,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999998,
              min: 0,
              controls: false,
              style: 'width: 100%'
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BalanceUSD'),
          field: 'balanceCurrencyUsd',
          width: 200,
          // 是否开启编辑
          editable: !this.locked,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999998,
              min: 0,
              controls: false,
              style: 'width: 100%'
            }
          }
        }
      ]
    },
    loadAccountTitleAuxiliaryBalance() {
      const params = {}
      params.accountTitle = this.accountTitle.accountTitle
      params.year = this.fiscalPeriod.year
      params.month = this.fiscalPeriod.month
      params.accountSetUuid = this.fiscalPeriod.accountSetUuid
      accountTitleAuxiliaryBalanceApi.loadAccountTitleAuxiliaryBalance(params).then(resp => {
        this.loadAccountTitleAuxiliaryBalanceHandler(resp)
      })
    },
    loadAccountTitleAuxiliaryBalanceHandler(resp) {
      const result = resp.data
      const resultCurrency = []
      if (result != null && result.length > 0) {
        for (const balance of result) {
          const balanceCurrency = balance.accountTitleAuxiliaryBalanceCurrency
          if (balanceCurrency.length > 0) {
            if (this.isMultiCurrency) {
              for (const accountTitleAuxiliaryBalanceCurrency of balanceCurrency) {
                const balanceNew = {}
                balanceNew.projectNumber2 = balance.uuid // key只读
                balanceNew.accountClient = balance.accountClient
                balanceNew.staffId = balance.staffId
                balanceNew.department = balance.department
                balanceNew.debitCrebit = balance.debitCrebit
                balanceNew.year = balance.year
                balanceNew.month = balance.month
                balanceNew.accountTitle = balance.accountTitle
                balanceNew.accountTitleName = accountTitleAuxiliaryBalanceCurrency.sourceCurrency // 币种(临时)
                balanceNew.balanceCurrencyRmb = accountTitleAuxiliaryBalanceCurrency.beginningBalance
                balanceNew.balanceCurrencyUsd = accountTitleAuxiliaryBalanceCurrency.sourceBeginningBalance
                resultCurrency.push(balanceNew)
              }
            } else {
              const accountTitleAuxiliaryBalanceCurrency = balanceCurrency[0]
              balance.balanceCurrencyRmb = accountTitleAuxiliaryBalanceCurrency.beginningBalance
              if (accountTitleAuxiliaryBalanceCurrency.sourceCurrency !== this.accountSet.localCurrency) {
                balance.balanceCurrencyUsd = accountTitleAuxiliaryBalanceCurrency.sourceBeginningBalance
              } else {
                balance.balanceCurrencyUsd = 0.0
              }
            }
          }
        }
      }
      if (this.isMultiCurrency) {
        this.accountTitleAuxiliaryBalances = resultCurrency
      } else {
        this.accountTitleAuxiliaryBalances = result
      }
    },
    addAuxiliaryEvent() {
      const accountTitleAuxiliaryBalance = {}
      accountTitleAuxiliaryBalance.debitCrebit = this.accountTitleBalance.debitCrebit
      // CARGO-7743,科目辅助期初区分账套
      accountTitleAuxiliaryBalance.accountSetUuid = this.accountSet.uuid
      this.accountTitleAuxiliaryBalances.push(accountTitleAuxiliaryBalance)
      this.locked = false
    },
    saveAuxiliaryEvent() {
      if (!this.accountTitleAuxiliaryBalances || this.accountTitleAuxiliaryBalances.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NPDOSB'))
        return
      }
      let saveFlag = true
      for (const balance of this.accountTitleAuxiliaryBalances) {
        if ((this.accountTitle.auxiliaryCustomer || this.accountTitle.auxiliarySupplier) && balance.accountClient <= 0) {
          this.$message.warning(this.accountTitle.auxiliaryCustomer ? this.$t('CargoMsg.Cargo_CLientCantBeEmpty') : this.$t('CargoMsg.Cargo_VendorCantBeEmpty'))
          saveFlag = false
          return
        }
        if (this.isMultiCurrency) {
          // 币种(临时)
          if (!balance.accountTitleName) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyCanTBeEmpty'))
            saveFlag = false
            return
          }
        }
      }
      if (saveFlag) {
        const params = {}
        params.accountTitleUuid = this.accountTitle.uuid
        params.accountTitleAuxiliaryBalances = this.accountTitleAuxiliaryBalances
        params.currency = this.currency
        if (this.isMultiCurrency) {
          accountTitleApi.saveAccountTitleAuxiliaryBalanceByMultiCurrency(params).then(resp => {
            this.saveAccountTitleAuxiliaryBalanceHandler()
          })
        } else {
          accountTitleApi.saveAccountTitleAuxiliaryBalance(params).then(resp => {
            this.saveAccountTitleAuxiliaryBalanceHandler()
          })
        }
      }
    },
    saveAccountTitleAuxiliaryBalanceHandler() {
      this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      this.loadAccountTitleAuxiliaryBalance()
    },
    removeAuxiliaryEvent() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataToDelete'))
        return
      }
      const nullRow = rows.filter(row => row.projectNumber2 === undefined || row.projectNumber2 == null || row.projectNumber2 === '')
      nullRow.forEach(row => {
        const index = this.accountTitleAuxiliaryBalances.findIndex(balance => row === balance)
        this.accountTitleAuxiliaryBalances.splice(index, 1)
      })

      if (this.isMultiCurrency) {
        const list = rows.filter(row => row.projectNumber2 && row.projectNumber2.length > 0)
        if (list.length > 0) {
          const params = {}
          params.accountTitleUuid = this.accountTitle.uuid
          params.accountTitleAuxiliaryBalances = list
          accountTitleApi.removeAccountTitleAuxiliaryBalanceByMultiCurrency(params).then(resp => {
            this.removeAccountTitleAuxiliaryBalanceHandler()
          })
        }
      } else {
        const list = rows.filter(row => row.projectNumber2 && row.projectNumber2.length > 0)
        if (list.length > 0) {
          const params = {}
          params.accountTitleUuid = this.accountTitle.uuid
          params.accountTitleAuxiliaryBalances = list
          accountTitleApi.removeAccountTitleAuxiliaryBalance(params).then(resp => {
            this.removeAccountTitleAuxiliaryBalanceHandler()
          })
        }
      }
    },
    removeAccountTitleAuxiliaryBalanceHandler() {
      this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
      this.removeSelectItems()
    },
    removeSelectItems() {
      const rows = this.gridOptions.api.getSelectedRows()
      const uuids = rows.map(row => row.projectNumber2)
      this.accountTitleAuxiliaryBalances = this.accountTitleAuxiliaryBalances.filter(row => !uuids.includes(row.projectNumber2))
    },
    closeHandler() {
      this.accountTitleAuxiliaryBalances = []
      this.$emit('close')
    },
    debitCrebitLablFun(value) {
      return value ? this.$t('CargoMsg.Cargo_Debit') : this.$t('CargoMsg.Cargo_Credit')
    },
    showCulomn() {
      if (this.accountTitle.auxiliaryCustomer || this.accountTitle.auxiliarySupplier) {
        this.gridOptions.columnApi.setColumnVisible('accountClient', true)
      }
      if (this.accountTitle.auxiliarySales) {
        this.gridOptions.columnApi.setColumnVisible('staffId', true)
      }
      if (this.accountTitle.auxiliaryDepartment) {
        this.gridOptions.columnApi.setColumnVisible('department', true)
      }
    }
  }
}
</script>

<style scoped>

</style>
